// Luxembourgish translations
export const lb: Record<string, string> = {
  'menu.dashboard': 'Dashboard',
  'menu.customers': 'Clienten',
  'menu.products': 'Produkter',
  'menu.users': 'Benotzer',
  'menu.settings': 'Astellungen',
  'menu.logout': 'Ofmellen',
  'dashboard.title': 'Dashboard',
  'dashboard.newOrder': 'Nei Bestellung',
  'order.title': 'Nei Bestellung',
  'order.customer': 'Client',
  'order.products': 'Produkter',
  'order.total': 'Total',
  'users.title': 'Benotzer',
  'users.name': 'Numm',
  'users.email': 'E-Mail',
  'common.yes': 'Jo',
  'common.no': 'Nee',
  'common.cancel': 'Ofbriechen',
  'common.save': 'Späicheren',
  'common.search': 'Sichen',
  'common.perPage': 'Per Page',
  'common.page': 'Page',
  'common.orders': 'Orders',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.pieces': 'pieces',
  'login.title': 'Cleandy',
  'login.login': 'Amelden',
  'login.welcome': 'Wëllkomm, {name}',
  'login.tagline': 'Dry cleaning software — Smart and easy solutions for your business.',
  'signup.email': 'E-Mail',
  'signup.phone': 'Telefon',
  'menu.reportsAndAccounting': 'Berichter & Comptabilitéit',
  'menu.systemAndCommunication': 'System & Kommunikatioun',
};